import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'

const LabelWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: '30px',
  left: '4px',
  zIndex: 1,
  padding: '4px',
  display: 'flex',
  gap: '4px',
  backgroundColor: '#F2F6FA',
  borderRadius: '4px',
  [theme.breakpoints.up('sm')]: {
    bottom: '12px',
    left: '12px',
    padding: '8px',
  },
}))

const SizeText = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'uppercase',
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
}))

const SizesLabel = ({ imageLabels }) => {
  if (!imageLabels) return null

  return (
    <LabelWrapper>
      {imageLabels?.map((sizeText, index) => (
        <React.Fragment key={sizeText}>
          <SizeText>{sizeText}</SizeText>
          {index !== imageLabels.length - 1 && <SizeText>•</SizeText>}
        </React.Fragment>
      ))}
    </LabelWrapper>
  )
}

SizesLabel.propTypes = {
  imageLabels: PropTypes.arrayOf(PropTypes.string),
}

export default SizesLabel
